import type {ReactNode} from 'react'
import {Link} from 'react-router-dom'
import {useTranslation} from 'react-i18next'
import {PorQue} from '@/components/ui/por-que'
import type {PerfilLineaRead} from '@/hooks/empresa/perfil_cargo/use-perfiles-cargo'

/** El número de fila es una posición, no un identificador: sin el enlace habría que contar filas. */
function ALaFila({
  businessId,
  riesgoFilaId,
  children,
}: {
  businessId: string | undefined
  riesgoFilaId: string | null | undefined
  children: ReactNode
}) {
  if (!businessId || !riesgoFilaId) return <>{children}</>
  return (
    <Link className="underline" to={`/businesses/${businessId}/sgsst/matriz-riesgos?fila=${riesgoFilaId}`}>
      {children}
    </Link>
  )
}

/** Sin disparador por fila: la traza la enciende por sección `TrazabilidadSwitch` y se imprime en
 * línea, para el papel y Ctrl+F (U10/T14). */
export function OrigenLinea({
  linea,
  businessId,
  desplegado,
}: {
  linea: PerfilLineaRead
  businessId?: string
  desplegado: boolean
}) {
  const {t} = useTranslation()
  if (!desplegado) return null
  return (
    <PorQue
      label={t('common.deDondeSalio')}
      titulo={t('common.deDondeSalio')}
      ariaLabel={`${t('common.deDondeSalio')} — ${linea.texto}`}
      contenidoTestId={`origen-contenido-${linea.clave}`}
      siempreVisible>
      <p>
        {linea.origen_tipo === 'riesgo_fila' ? (
          <ALaFila businessId={businessId} riesgoFilaId={linea.riesgo_fila_id}>
            {t('perfilCargo.origen.riesgo_fila', {fila: linea.numero_fila ?? linea.origen_ref ?? ''})}
          </ALaFila>
        ) : linea.origen_tipo === 'ficha_trabajador' || linea.origen_tipo === 'entrevista' ? (
          // El autor puede faltar: se dice «un titular del cargo» en vez de un hueco.
          linea.origen_detalle ? (
            t(`perfilCargo.origen.${linea.origen_tipo}`, {autor: linea.origen_detalle})
          ) : (
            t(`perfilCargo.origen.${linea.origen_tipo}_sin_autor`)
          )
        ) : linea.origen_tipo === 'catalogo_inci' && linea.origen_detalle ? (
          `${t('perfilCargo.origen.catalogo_inci')} — ${linea.origen_detalle}`
        ) : (
          t(`perfilCargo.origen.${linea.origen_tipo}`)
        )}
        {linea.declarantes !== null && linea.total_personas !== null && linea.declarantes > 0 && (
          <>
            {' · '}
            {t('perfilCargo.declarantes', {
              declarantes: linea.declarantes,
              total: linea.total_personas,
            })}
          </>
        )}
        {linea.del_area && <> · {t('perfilCargo.delArea')}</>}
      </p>
    </PorQue>
  )
}
